import axios from 'axios';
// Get the API URL from environment variables
const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';
console.log('API URL:', apiUrl); // Debug log
const api = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json'
    },
    // Remove withCredentials to avoid CORS issues in production
    withCredentials: false
});
// Add request interceptor to include auth token
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    console.log('Request URL:', `${config.baseURL || ''}${config.url || ''}`); // Debug log
    return config;
}, (error) => {
    return Promise.reject(error);
});
// Add response interceptor to handle errors
api.interceptors.response.use((response) => response, (error) => {
    console.error('API Error:', error.response?.status, error.response?.data); // Debug log
    if (error.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
    }
    return Promise.reject(error);
});
export default api;
